import React, { useEffect, useState } from 'react';
import './logging.css';
import SftGlobalData from '../../library/SftGlobalData';
import axios from 'axios';
import StoresTable from '../../components/logging/StoresTable';
import CustomersTable from '../../components/logging/CustomersTable';
import EmailsTable from '../../components/logging/EmailsTable';

/**
 * Customers, stores and e-mails (Zoho matching). Formerly its own page (/logging/customers); now the three
 * right-aligned tabs of the logging overview. `tab` 0 = customers, 1 = stores, 2 = e-mails.
 * Stays mounted while the overview is open, so the data is fetched once (on the first visit of one of these tabs).
 */
const LoggingCustomersPanels = (props) =>  {
    const [loading, setLoading] = useState(false);
    const tab = props.tab;

    const [initialGridCustomers, setInitialGridCustomers] = useState(getCookie("initialStateCustomers") === "{}" ? {columns: {columnVisibilityModel: {},}} : JSON.parse(getCookie("initialStateCustomers")));
    const [initialGridStores, setInitialGridStores] = useState(getCookie("initialStateStores") === "{}" ? {columns: {columnVisibilityModel: {name2: false, address2: false, tel2: false, fax: false, fax2: false,},}} : JSON.parse(getCookie("initialStateStores")));

    const [customers, setCustomers] = useState([]);
    const [stores, setStores] = useState([]);
    const [proposedEmails, setProposedEmails] = useState([]);
    const [customersWithEmails, setCustomersWithEmails] = useState([]);

    useEffect(()=>{
        if(!loading){
            setLoading(true);
            loadCustomers();
            loadStores();
            loadProposedEmails();
            loadCustomersWithEmails();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.loginObj]);

    // Switching between these tabs: pick up the column layout saved by the other grid (as the old page did).
    useEffect(() => {
        if(getCookie("initialStateCustomers") !== "{}"){
            let temp = JSON.parse(getCookie("initialStateCustomers"));
            try{
                temp.preferencePanel.open = false;
            }catch(e){

            }
            setInitialGridCustomers(temp);
        }
        if(getCookie("initialStateStores") !== "{}"){
            let temp2 = JSON.parse(getCookie("initialStateStores"));
            try{
                temp2.preferencePanel.open = false;
            }catch(e){

            }
            setInitialGridStores(temp2);
        }
    }, [tab]);

    const loadCustomers = () => {
        try{
            let url = SftGlobalData.baseURL_API+'login';
            let postData = {action: "logging", login: props.loginObj?.login, password: props.loginObj?.password}
            axios.post(url, postData, {
                headers : {
                    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
                }})
                .then(response => {
                    if(SftGlobalData.debug){
                        console.log('url', url);
                        console.log('postData', postData);
                        console.log('resp loadCustomers', response);
                    }
                    setCustomers(response.data);
                    setLoading(false);
                })
                .catch(e => {
                    console.error('loadCustomers', e);
                    setLoading(false);
                });
        } catch(e){
            console.error(e);
        }
    }

    const loadStores = () => {
        SftGlobalData.post('logging&action=fetchDeliveryAddress', {type: props.sftStatus, sft_id: 0, sft: props.loginObj?.sft_status}).then(response => {
            setStores(response.data);
        });
    }

    const loadProposedEmails = () => {
        SftGlobalData.post('logging&action=fetchProposedEmails', {type: props.sftStatus, sft_id: 0, sft: props.loginObj?.sft_status}).then(response => {
            setProposedEmails(response.data);
        });
    }

    const loadCustomersWithEmails = () => {
        let url2 = "https://app.softtouch.eu/zoho/routes.php?action=getAllContacts";
        let postData2 = {type: props.sftStatus, sft_id: 0, sft: props.loginObj?.sft_status};
        axios.post(url2, postData2, {
            headers : {
                'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
            }})
        .then(response => {
            if(SftGlobalData.debug){
                console.log('url', url2);
                console.log('postData', postData2);
                console.log('response customers wih emails', response);
            }
            setCustomersWithEmails(response.data?.data);
        })
        .catch(e => {
            // app.softtouch.eu/zoho currently answers 404 (no CORS headers -> "Network Error");
            // the Zoho tab then stays empty instead of crashing the page.
            console.warn('Zoho contacts unavailable', e?.message);
            setCustomersWithEmails([]);
        });
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "{}";
    }

    return (
        <>
            {tab === 0 && <CustomersTable fill login={props.loginObj} lang={props.lang} loadCustomers={()=>{loadCustomers();}} userId={props.userId} initialGrid={initialGridCustomers} data={customers} loading={loading} t={props.t} theme={props.theme} />}
            {tab === 1 && <StoresTable fill login={props.loginObj} loadStores={()=>{loadStores();}} userId={props.userId} initialGrid={initialGridStores} data={stores} loading={loading} t={props.t} theme={props.theme} />}
            {tab === 2 && <EmailsTable fill login={props.loginObj} loadProposedEmails={()=>{loadProposedEmails();}} loadCustomers={()=>{loadCustomersWithEmails();}} userId={props.userId} initialGrid={initialGridStores} data={proposedEmails} customers={customersWithEmails} loading={loading} t={props.t} theme={props.theme} />}
        </>
    );
}

export default LoggingCustomersPanels;
